import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENTITY_NAME_TOKEN } from '@app/core/interceptors/context.tokens';
import { ErrorMappingService } from '@app/core/services/error-mapping/error-mapping.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { catchError, throwError } from 'rxjs';

export const globalErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const errorMappingService = inject(ErrorMappingService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const entityName = req.context.get(ENTITY_NAME_TOKEN);
      const errorMessage = errorMappingService.getGermanErrorMessage(error, entityName);
      notificationService.showErrorMessage(errorMessage);
      return throwError(() => error);
    }),
  );
};
